import React from "react";
import { Carousel } from "antd";
import Row from "./Row";
import { useGetMediaQuery } from "../hooks/useMediaQuery";

type CarouselRowProps = {
  children: React.ReactNode[];
  mobileGroup?: number;
  desktopGroup?: number;
};

const CarouselRow: React.FC<CarouselRowProps> = ({
  children,
  mobileGroup = 1,
  desktopGroup = 3,
}) => {
  const { isMobile } = useGetMediaQuery();
  const group = isMobile ? mobileGroup : desktopGroup;

  const groupCount = Math.ceil(children.length / group);
  const groupChildren = Array.from({ length: groupCount }, (_, index) => {
    const startIndex = index * group;
    return children.slice(startIndex, startIndex + group);
  });

  return (
    <Carousel arrows className="CarouselRow">
      {groupChildren.map((group, index) => (
        <Row key={index}>{group}</Row>
      ))}
    </Carousel>
  );
};

export default CarouselRow;
